<div class="flex items-start space-x-2 mb-4">
  <div class="flex items-center">
    <mat-icon svgIcon="heroicons_outline:exclamation-triangle" class="text-red-500 ml-4 mt-6" style="font-size: 32px"></mat-icon>
  </div>

  <div class="grid w-full">
    <h2 mat-dialog-title class="text-lg font-bold mb-1">
      Seleccione una ruta
    </h2>

    <mat-dialog-content class="w-full">
      <form [formGroup]="form" class="w-full">
        <div *ngIf="data.subSroutes?.length > 0">
          <mat-form-field appearance="outline" class="w-full">
            <mat-select formControlName="selectedSubRoute" panelClass="wide-select">
              <mat-option *ngFor="let subRoute of data.subSroutes" [value]="subRoute">
                <span>
                  <b *ngIf="getCode(subRoute) as code">
                    {{ code }} -
                  </b>{{ subRoute.name }}
                </span>
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div *ngIf="!data.subSroutes || data.subSroutes.length === 0">
          <p class="text-red-500">No hay Rutas disponibles para seleccionar</p>
        </div>
      </form>
    </mat-dialog-content>
  </div>
</div>

<mat-dialog-actions class="modal-actions flex justify-end gap-2">
  <button mat-button color="warn" (click)="onCancel()">Cancelar</button>
  <button mat-raised-button color="primary" (click)="onConfirm()" [disabled]="!form.controls.selectedSubRoute.valid">
    Confirmar
  </button>
</mat-dialog-actions>
